import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useNavigate } from 'react-router-dom'

import styles from './ResetPassword.module.css'

import EntryForm, { EntryFormContainer } from 'Layout/EntryForm'
import FormControl from 'Design/components/FormControl'
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import Button from 'Design/components/Button'

import resetPasswordFormValidationSchema from './reset-password-form-validation-schema'
import { useResetPasswordMutation } from './reset-password.service'
import Heading from 'Design/components/Heading'
import FormErrorText from 'Design/components/FormErrorText'

const ResetPassword = () => {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting }
  } = useForm({
    defaultValues: {
      email: ''
    },
    mode: 'onBlur',
    reValidateMode: 'onChange',
    resolver: yupResolver(resetPasswordFormValidationSchema)
  })

  const [restPassword, resetPasswordResult] = useResetPasswordMutation()
  const navigate = useNavigate()

  const [error, setError] = useState(null)

  const onFormSubmit = async (data) => {
    const payload = {
      email: data.email
    }

    const promise = restPassword(payload).unwrap()
    await promise
      .then(() => {
        navigate('./success', { state: { email: data.email } })
      })
      .catch((e) => {
        setError(e?.data?.message || 'Unable to reset password. Please try again.')
        console.error('Unable to reset password', e)
      })
  }

  const isResetting = isSubmitting || resetPasswordResult.isLoading

  return (
    <EntryForm>
      <EntryFormContainer>
        {error && <div className={styles.ErrorMessage}>{error}</div>}
        <form className={styles.Form} onSubmit={handleSubmit(onFormSubmit)}>
          <Heading level={2}>Forgot Password?</Heading>
          <p className={styles.Description}>
            Enter your email address and we'll send you <br /> a link to reset your password
          </p>

          <FormControl isInvalid={errors.email}>
            <Label htmlFor='email'>Email</Label>
            <Input
              type='text'
              id='email'
              {...register('email')}
              placeholder='Enter your email'
              onChange={() => setError(null)}
            />
            {errors.email && <FormErrorText>{errors.email.message}</FormErrorText>}
          </FormControl>

          <Button variant='primary' type='submit' className={styles.PrimaryBtn}>
            {isResetting ? 'Sending' : 'Send'} Password Reset Email
          </Button>
        </form>
      </EntryFormContainer>
    </EntryForm>
  )
}

export default ResetPassword
